import { flex, margin, gap } from '@ebh/capsule/theme';

export default {
  passwordRules: [flex('column'), gap(3), margin(2, 'top')],
  ruleItem: [flex('row', 'items-center'), gap(2)],
  ruleIcon: [{ width: 16, height: 16 }],
};
